module.exports = __webpack_public_path__ + "a70ed932491173d32dfe67564963dc37.svg";